import { useQuery } from "@tanstack/react-query";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { authHeader } from "@/utils/headers";
import { useActiveOrganization } from "@/hooks/organizations";

export const useGetWorkspaces = ({
  perPage = 100,
  page = 1,
  organizationId,
  search,
}: {
  perPage?: number;
  page?: number;
  organizationId?: number;
  search?: string;
}) => {
  const authContext = useAuth();
  const { data: activeOrganization } = useActiveOrganization();
  const activeOrganizationId = activeOrganization?.id;

  const uri = new URL(ENDPOINTS.get_workspaces);

  if (organizationId) {
    uri.searchParams.set("organization_id", organizationId.toString());
  } else if (activeOrganizationId) {
    uri.searchParams.set("organization_id", activeOrganizationId.toString());
  }

  uri.searchParams.append("per_page", perPage.toString());
  uri.searchParams.append("page", page.toString());

  if (search?.trim()) {
    uri.searchParams.set("q", search.trim());
  }

  return useQuery(
    [ENDPOINTS.get_workspaces, organizationId ?? activeOrganizationId, page, perPage, search ?? ""],
    () =>
      fetch(uri.toString(), {
        method: "GET",
        headers: authHeader(authContext?.userToken ?? ""),
      }).then(handleResponse),
    {
      enabled: !!organizationId || !!activeOrganizationId,
    },
  );
};
